import { render, staticRenderFns } from "./AddEditContent.vue?vue&type=template&id=6facf272&lang=pug&"
import script from "./AddEditContent.vue?vue&type=script&lang=js&"
export * from "./AddEditContent.vue?vue&type=script&lang=js&"
import style0 from "./AddEditContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports